import { AfterViewInit, Component, NgZone, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as Feather from 'feather-icons';
import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { CommunicationInterfaceService } from 'src/app/services/communicationInterface/communication-interface.service';
import { $b } from '../../../libs/browser_utils.js';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit, AfterViewInit {
  appConfig: any;
  TopNavButtonType: any;
  encryptKey = 'ThisIsTheSecret';
  LogoutBtn: any;
  endButtonIcon = 'close';
  disableLoading: boolean;
  buttonText: string;

  constructor(
    private appDataService: AppdataService,
    private commInterface: CommunicationInterfaceService,
    public zone: NgZone
  ) {
    console.log('%c LoadingComponent', 'color:white; background: blue;');
    this.commInterface.logToServer('info', 'LoadingComponent.constructor', 'Loading component initialized');
  }

  ngOnInit(): void {
    try {
      this.appConfig = this.appDataService.getConfig();
      this.TopNavButtonType = this.appConfig.TopNavButton.type;
      this.LogoutBtn = this.appConfig.TopNavButton.LogoutVisibileAlways;
      this.endButtonIcon = this.appConfig.TopNavButton.endButtonIcon;
      this.buttonText = this.appConfig?.TopNavButton?.buttonText;
      this.disableLoading = this.appConfig.Miscellaneous.disableLoading;
    } catch (error) {
      console.error('%c Error Occured in ngOnInit', 'color: red', error);
      this.commInterface.sendUIErrors('LoadingComponent', 'ngOnInit', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in LoadingComponent.ngOnInit', JSON.stringify(error));
    }
  }

  ngAfterViewInit() {
    Feather.replace();
  }

  decryptAppConfig() {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  }
}
